import React, { useMemo } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import barvelikaslika from "../../assets/img/bg/barvelikaslika.webp";
import barzalazak from "../../assets/img/bg/barzalazak.webp";
import kraljnikola from "../../assets/img/bg/kraljnikola.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function PageSidebar() {
  const [t] = useTranslation();

  return (
    <aside className="sidebar-widget">
      <section
        id="custom_html-5"
        className="widget_text widget widget_custom_html"
      >
        <h2 className="widget-title">{t("sidebar.follow")}</h2>
        <div className="textwidget custom-html-widget">
          <div className="widget-social">
            <a
              href="https://www.facebook.com/fpebar.me"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
            >
              <i className="fab fa-facebook-f" />
            </a>
            <a
              href="https://www.instagram.com/fpepbar/"
              target="_blank"
              rel="noopener noreferrer"
              title="Instagram"
            >
              <i className="fab fa-instagram" />
            </a>
            <a
              href="https://www.youtube.com/@fpepbar"
              target="_blank"
              rel="noopener noreferrer"
              title="YouTube"
            >
              <i className="fab fa-youtube" />
            </a>
            <a
              href="https://www.tiktok.com/@fpepbar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Tiktok"
              title="Tiktok"
            >
              <i className="fab fa-tiktok" />
            </a>
            <a
              href="https://www.linkedin.com/school/fpepbar/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on LinkedIn"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin-in" />
            </a>
          </div>
        </div>
      </section>

      <section id="categories-1" className="widget widget_categories">
        <h2 className="widget-title">{t("sidebar.useful")}</h2>
        <ul>
          <li className="cat-item cat-item-16">
            <Link to="/o-fpep">{t("about.fpep")}</Link>
          </li>
          <li className="cat-item cat-item-23">
            <Link to="/akreditacija-fpep">{t("admission.Akreditacija")}</Link>
          </li>
          <li className="cat-item cat-item-18">
            <Link to="/upis">{t("upis.title")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/projekti">{t("saradnja.projekti")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/dom-studenata">{t("studenti.dom")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/galerija">{t("navbar.Gallery")}</Link>
          </li>
          <li className="cat-item cat-item-22">
            <Link to="/novosti">{t("navbar.News")}</Link>
          </li>
        </ul>
      </section>

      <section id="recent-posts-4" className="widget widget_recent_entries">
        <h2 className="widget-title">{t("sidebar.study")}</h2>
        <ul>
          <li>
            <span className="post-date">
              <strong>{t("programs.osnovne")}</strong> <br />
            </span>
            <Link to="/racunovodstvo-finansije-i-bankarstvo">
              {t("osnovne.rfb")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/menadzment">
              {t("osnovne.menadzment")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/pravo-osnovne">
              {t("osnovne.pravo")}
              <br />
            </Link>
          </li>

          <li>
            <span className="post-date">
              <strong>{t("programs.master")}</strong> <br />
            </span>
            <Link to="/poslovna-ekonomija">
              {t("master.poslovnaEkonomija")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/ekonomija-javnog-sektora">
              {t("master.ekonomijaJavnogSektora")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/pravo-master">
              {t("master.pravo")}
              <br />
            </Link>
          </li>

          <li>
            <span className="post-date">
              <strong>{t("programs.specijalisticke")}</strong> <br />
            </span>
            <Link to="/menadzment-javnog-sektora-specijalisticke">
              {t("specijalisticke.mjs")}
              <br />
            </Link>
          </li>
          <li>
            <Link to="/menadzment-profitnog-sektora-specijalisticke">
              {t("specijalisticke.mps")}
              <br />
            </Link>
          </li>
        </ul>
      </section>
    </aside>
  );
}

function OBaru() {
  const [t] = useTranslation();

  const pageTitle = t("bar.title");

  const highlights = useMemo(() => {
    const v = t("bar.highlights", { returnObjects: true });
    if (Array.isArray(v) && v.length) return v;

    return [
      {
        title: t("bar.h1Title", {
          defaultValue: "Masline kao identitet grada",
        }),
        text: t("bar.h1Text", {
          defaultValue:
            "Bar je poznat po maslinarstvu i starim maslinjacima - simbol mediteranskog karaktera grada.",
        }),
        icon: "fas fa-leaf",
      },
      {
        title: t("bar.h2Title", {
          defaultValue: "Stari Bar i slojevita istorija",
        }),
        text: t("bar.h2Text", {
          defaultValue:
            "Stari Bar i arheološki tragovi prave ga mjestom gdje se istorija vidi, ne samo čita.",
        }),
        icon: "fas fa-landmark",
      },
      {
        title: t("bar.h3Title", { defaultValue: "More, šetnje i zalasci" }),
        text: t("bar.h3Text", {
          defaultValue:
            "Obala, marina i zalazak sunca su Bar u jednoj rečenici: opušteno, toplo, ljudski.",
        }),
        icon: "fas fa-water",
      },
      {
        title: t("bar.h4Title", { defaultValue: "Kultura i događaji" }),
        text: t("bar.h4Text", {
          defaultValue:
            "Barski ljetopis i brojni programi tokom godine daju gradu ritam koji se osjeća i van sezone.",
        }),
        icon: "fas fa-theater-masks",
      },
    ];
  }, [t]);

  return (
    <>
      <Navbar />
      <Bredcom
        title={t("breadcrumb.home", { defaultValue: "Početna" })}
        subtitle={t("pages.o-baru", { defaultValue: pageTitle })}
      />

      <div className="container">
        <div className="row">
          <div className="col-lg-8 pt-40">
            <main className="o-baru bar-page" aria-label={pageTitle}>
              {/* HERO */}
              <header className="bar-hero">
                <div className="bar-hero__wrap">
                  <div className="bar-hero__copy">
                    <span className="bar-hero__badge">
                      <i className="fas fa-map-marker-alt" aria-hidden="true" />{" "}
                      {t("bar.ui.badge", { defaultValue: "O Baru" })}
                    </span>

                    <h2 className="bar-hero__title">
                      {t("bar.heroTitle", {
                        defaultValue: "Bar - grad maslina, mora i istorije",
                      })}
                    </h2>

                    <p className="bar-hero__lead">
                      {t("bar.heroLead", {
                        defaultValue:
                          "Brzi vodič za naše partnere i goste: šta Bar čini posebnim, gdje se nalazi Fakultet i kako da dobijete zvanične, aktuelne turističke informacije.",
                      })}
                    </p>

                    <div className="bar-hero__actions">
                      <a
                        className="bar-btn bar-btn--primary"
                        href="#bar-faculty"
                      >
                        {t("bar.heroCtaPrimary", {
                          defaultValue: "Gdje je FPEP?",
                        })}
                      </a>

                      <a
                        className="bar-btn bar-btn--ghost"
                        href="https://bar.travel/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("bar.heroCtaSecondary", {
                          defaultValue: "Bar Travel",
                        })}
                      </a>
                    </div>

                    <div
                      className="bar-hero__chips"
                      aria-label={t("bar.ui.quickNav", {
                        defaultValue: "Brza navigacija",
                      })}
                    >
                      <a className="bar-chip" href="#bar-highlights">
                        {t("bar.ui.chip1", { defaultValue: "Highlights" })}
                      </a>
                      <a className="bar-chip" href="#bar-story">
                        {t("bar.ui.chip2", { defaultValue: "Priča" })}
                      </a>
                      <a className="bar-chip" href="#bar-map">
                        {t("bar.ui.chip3", { defaultValue: "Mapa" })}
                      </a>
                    </div>
                  </div>

                  <div
                    className="bar-hero__media"
                    aria-label={t("bar.ui.mediaAria", {
                      defaultValue: "Fotografije Bara",
                    })}
                  >
                    <div className="bar-mosaic">
                      <figure className="bar-mosaic__big">
                        <img
                          src={barvelikaslika}
                          fetchpriority="high"
                          decoding="async"
                          alt={t("bar.ui.imgAlt1", {
                            defaultValue: "Bar - panorama",
                          })}
                        />
                        <figcaption>
                          <span>
                            {t("bar.ui.cap1", {
                              defaultValue: "Bar u jednom kadru",
                            })}
                          </span>
                        </figcaption>
                      </figure>

                      <figure className="bar-mosaic__small">
                        <img
                          src={barzalazak}
                          loading="lazy"
                          decoding="async"
                          alt={t("bar.ui.imgAlt2", {
                            defaultValue: "Zalazak sunca u Baru",
                          })}
                        />
                        <figcaption>
                          <span>
                            {t("bar.ui.cap2", {
                              defaultValue: "Zalazak sunca",
                            })}
                          </span>
                        </figcaption>
                      </figure>

                      <figure className="bar-mosaic__small">
                        <img
                          src={kraljnikola}
                          loading="lazy"
                          decoding="async"
                          alt={t("bar.ui.imgAlt3", {
                            defaultValue: "Dvorac kralja Nikole u Baru",
                          })}
                        />
                        <figcaption>
                          <span>
                            {t("bar.ui.cap3", { defaultValue: "Kralj Nikola" })}
                          </span>
                        </figcaption>
                      </figure>
                    </div>

                    <p className="bar-hero__caption">
                      {t("bar.ui.mediaCaption")}
                    </p>
                  </div>
                </div>
              </header>

              {/* HIGHLIGHTS */}
              <section id="bar-highlights" className="bar-section">
                <div className="bar-section__head">
                  <h3 className="bar-section__title">
                    {t("bar.highlightsTitle", {
                      defaultValue: "Ukratko o Baru",
                    })}
                  </h3>
                  <p className="bar-section__hint">
                    {t("bar.highlightsHint", {
                      defaultValue:
                        "Za detalje i aktuelne preporuke: Bar Travel.",
                    })}
                  </p>
                </div>

                <div className="bar-cards">
                  {highlights.map((h, idx) => (
                    <article key={`${h.title}-${idx}`} className="bar-card">
                      <div className="bar-card__icon" aria-hidden="true">
                        <i className={h.icon || "fas fa-star"} />
                      </div>
                      <h4 className="bar-card__title">{h.title}</h4>
                      <p className="bar-card__text">{h.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              {/* STORY (existing content, but presented professionally) */}
              <section id="bar-story" className="bar-section">
                <div className="bar-story">
                  <header className="bar-story__head">
                    <h3 className="bar-section__title">
                      {t("bar.storyTitle", { defaultValue: "Upoznajte Bar" })}
                    </h3>
                    <p className="bar-section__hint">
                      {t("bar.storyHint", {
                        defaultValue:
                          "Tekst ostaje tvoj - samo je prikaz sada na nivou.",
                      })}
                    </p>
                  </header>

                  <article className="bar-block">
                    <h4 className="bar-block__title">
                      {t("bar.block1Title", {
                        defaultValue: "Grad mora, luke i maslina",
                      })}
                    </h4>
                    <div className="bar-prose">
                      <p>{t("bar.p1")}</p>
                      <p>{t("bar.p2")}</p>
                      <p>{t("bar.p3")}</p>
                    </div>
                  </article>

                  <article className="bar-block">
                    <h4 className="bar-block__title">
                      {t("bar.block2Title", {
                        defaultValue: "Zalazak, obala i ritam grada",
                      })}
                    </h4>
                    <div className="bar-prose">
                      <p>{t("bar.p4")}</p>
                      <p>{t("bar.p5")}</p>
                      <p>{t("bar.p6")}</p>
                    </div>
                  </article>

                  <article className="bar-block">
                    <h4 className="bar-block__title">
                      {t("bar.block3Title", {
                        defaultValue: "Kralj Nikola i kulturna baština",
                      })}
                    </h4>
                    <div className="bar-prose">
                      <p>{t("bar.p7")}</p>
                      <p>{t("bar.p8")}</p>
                      <p>{t("bar.p9")}</p>
                    </div>
                  </article>
                </div>
              </section>

              {/* FPEP IN BAR */}
              <section id="bar-faculty" className="bar-section">
                <div className="bar-faculty">
                  <div className="bar-faculty__copy">
                    <h3 className="bar-section__title">
                      {t("bar.facultyTitle", { defaultValue: "FPEP u Baru" })}
                    </h3>
                    <p className="bar-section__hint">
                      {t("bar.facultyLead", {
                        defaultValue:
                          "Fakultet se nalazi u Baru - zato ovu stranicu doživljavaj kao mali “welcome pack” za goste koji dolaze na saradnju, predavanja ili posjetu.",
                      })}
                    </p>

                    <div className="bar-faculty__actions">
                      <Link className="bar-btn bar-btn--primary" to="/kontakt">
                        {t("bar.facultyCtaContact", {
                          defaultValue: "Kontakt i lokacija",
                        })}
                      </Link>
                      <Link className="bar-btn bar-btn--ghost" to="/o-fpep">
                        {t("bar.facultyCtaAbout", {
                          defaultValue: "O Fakultetu",
                        })}
                      </Link>
                    </div>
                  </div>

                  <div className="bar-faculty__map">
                    <div className="bar-mapFrame">
                      <iframe
                        title={t("bar.facultyMapTitle", {
                          defaultValue: "Mapa - FPEP Bar",
                        })}
                        src="https://www.google.com/maps?q=Fakultet%20za%20poslovnu%20ekonomiju%20i%20pravo%20Bar&z=15&output=embed"
                        width="100%"
                        height="360"
                        frameBorder="0"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>

                    <p className="bar-mapNote">
                      {t("bar.facultyMapHint", {
                        defaultValue:
                          "Klikni mapu za navigaciju. Za turističke informacije i rute - Bar Travel.",
                      })}
                    </p>
                  </div>
                </div>
              </section>

              {/* MAP BAR */}
              <section id="bar-map" className="bar-section">
                <div className="bar-section__head">
                  <h3 className="bar-section__title">
                    {t("bar.mapTitle", { defaultValue: "Mapa grada" })}
                  </h3>
                  <p className="bar-section__hint">
                    {t("bar.mapHint", {
                      defaultValue: "Zumirajte Bar i okolinu",
                    })}
                  </p>
                </div>

                <div className="bar-mapFrame">
                  <iframe
                    title={t("bar.mapTitle", { defaultValue: "Mapa - Bar" })}
                    src="https://www.google.com/maps?q=Bar%2C%20Montenegro&z=12&output=embed"
                    width="100%"
                    height="420"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </section>

              {/* PROMO Bar Travel (keep) */}
              <section
                className="bar-promo"
                aria-label={t("bar.promotionTitle")}
              >
                <div className="bar-promo__inner">
                  <h3 className="bar-promo__title">
                    {t("bar.promotionTitle")}
                  </h3>
                  <p className="bar-promo__text">{t("bar.promotionText")}</p>

                  <a
                    href="https://bar.travel/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bar-btn bar-btn--primary"
                  >
                    {t("bar.visitSite")}
                  </a>
                </div>
              </section>
            </main>
          </div>

          <div className="col-md-4 pt-110">
            <PageSidebar />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default OBaru;
